import { useContext } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

import { FlyoutContentContext } from './FlyoutContext';

const FlyoutContent = ({ children }) => {
  const ref = useContext(FlyoutContentContext);
  return ref && ref.current ? createPortal(children, ref.current) : null;
};

FlyoutContent.propTypes = {
  children: PropTypes.node,
};

export default FlyoutContent;
